import { connect } from 'react-redux';

import { dismissPopup } from 'app/marketplace/SlideInBanners/shared/redux/actions';

import { SweepstakesBanner } from './SweepstakesBanner';

const mapStateToProps = (state) => ({
  areCookiesAccepted: state.cookieDashboard.preferences.functional,
});

export const ConnectedSweepstakesBanner = connect(mapStateToProps, {
  onClose: dismissPopup,
})(SweepstakesBanner);
